import { Link } from 'react-router-dom';

interface HeroProps {
  title: string;
  subtitle: string;
  ctaText: string;
  ctaLink: string;
  secondaryText: string;
  secondaryLink: string;
}

export default function Hero({ title, subtitle, ctaText, ctaLink, secondaryText, secondaryLink }: HeroProps) {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20professional%20Chinese%20office%20workspace%20with%20elegant%20warm%20ambient%20lighting%2C%20sophisticated%20minimalist%20design%2C%20clean%20architectural%20lines%2C%20large%20windows%20with%20soft%20natural%20light%20streaming%20through%2C%20warm%20cream%20and%20gold%20tones%2C%20refined%20editorial%20photography%20style%20with%20harmonious%20composition%20and%20negative%20space&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
          alt="17.c 起草官网专业办公环境"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading leading-tight mb-6">
            {title}
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto mb-10">
            {subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to={ctaLink}
              className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {ctaText}
            </Link>
            <Link
              to={secondaryLink}
              className="px-8 py-3.5 rounded-lg border border-white/30 text-white text-base font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {secondaryText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}